import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiPlus } from 'react-icons/hi2';
import styles from './Projects.module.css';

const ProjectsHeader = ({ showNewProjectMenu, setShowNewProjectMenu, setShowCreateModal, walkthrough }) => {
  const navigate = useNavigate();
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  useEffect(() => {
    if (!isVideoOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsVideoOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isVideoOpen]);

  const hasWalkthrough = Boolean(walkthrough?.embedUrl);

  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.headerText}>
          <h1 className={styles.headerTitle}>Active Projects</h1>
          <p className={styles.headerSubtitle}>
            Track projects in progress and completed work
          </p>
          {hasWalkthrough && (
            <div className={styles.walkthroughRow}>
              <button
                type="button"
                className={styles.walkthroughButton}
                onClick={() => setIsVideoOpen(true)}
              >
                <svg
                  className={styles.walkthroughIcon}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M8 5.14v13.72a1 1 0 0 0 1.55.83l9.2-6.86a1 1 0 0 0 0-1.66l-9.2-6.86A1 1 0 0 0 8 5.14z" />
                </svg>
                Watch walkthrough
              </button>
              {walkthrough?.durationLabel && (
                <span className={styles.walkthroughDuration}>
                  {walkthrough.durationLabel}
                </span>
              )}
            </div>
          )}
          {isVideoOpen && (
            <div
              className={styles.videoModalOverlay}
              onClick={() => setIsVideoOpen(false)}
            >
              <div
                className={styles.videoModal}
                onClick={(event) => event.stopPropagation()}
              >
                <div className={styles.videoModalHeader}>
                  <div className={styles.videoModalTitle}>
                    {walkthrough?.title || 'Projects walkthrough'}
                  </div>
                  <button
                    type="button"
                    className={styles.videoModalClose}
                    onClick={() => setIsVideoOpen(false)}
                    aria-label="Close video"
                  >
                    ✕
                  </button>
                </div>

                <div className={styles.videoFrame}>
                  <iframe
                    src={walkthrough.embedUrl}
                    title={walkthrough?.title || 'Projects walkthrough'}
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        
        <div className={styles.headerActions}>
          <div className={styles.dropdown}>
            <button
              onClick={() => setShowNewProjectMenu(!showNewProjectMenu)}
              className={styles.newProjectButton}
            >
              <HiPlus className={styles.buttonIcon} />
              New Project
            </button>
            
            {showNewProjectMenu && (
              <div className={styles.dropdownMenu}>
                <button
                  onClick={() => {
                    navigate('/enquiries');
                    setShowNewProjectMenu(false);
                  }}
                  className={styles.dropdownItem}
                >
                  <div className={styles.dropdownItemTitle}>Convert Enquiry</div>
                  <div className={styles.dropdownItemDescription}>
                    Convert an existing enquiry to project
                  </div>
                </button>
                <button
                  onClick={() => {
                    setShowCreateModal(true);
                    setShowNewProjectMenu(false);
                  }}
                  className={styles.dropdownItem}
                >
                  <div className={styles.dropdownItemTitle}>Start Fresh Project</div>
                  <div className={styles.dropdownItemDescription}>
                    Create and start immediately
                  </div>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsHeader;